<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">

        <strong > Member Information </strong>
            <CRow >
            <CCol >
                <Clabel>Firstname</Clabel>
                <CInput v-model="form.firstname" placeholder='First name' class="mb-1" />
              </CCol>
              <CCol >
                <Clabel>Lastname</Clabel>
                 <CInput v-model="form.lastname" placeholder='Last name' class="mb-1" />
              </CCol>
            </CRow>
            <CRow class="mt-2"> 
               <CCol lg="6">   
              <CInput v-model="form.alias" placeholder='Nickname' class="mb-1" />
               </CCol>
            </CRow>
            <hr>
            <CRow class="mt-2"> 
               <CCol lg="6">   
               <CInput v-model="form.dob" type="date" label="Date of Birth"   />
               </CCol>
            </CRow>
            
            <CRow >
              <CCol lg="6">
                <b-form-group label="Sex">
                  <b-form-radio v-model="form.sex" name="some-radios" value="male">Male</b-form-radio>
                  <b-form-radio v-model="form.sex" name="some-radios" value="female">Female</b-form-radio>
                </b-form-group>
              </CCol>
            </CRow>
            
            <strong > Contact Information </strong>
             <CRow >
               <CCol>
             <CInput v-model="form.email" label="Email" placeholder='Email' class="mb-1" />
               </CCol>
              <CCol>
             <CInput v-model="form.mobile_phone" label="Mobile Phone" placeholder='Mobile Phone' class="mb-1" />
              </CCol>
            </CRow>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>

import moment from 'moment';
import EventBus from '@/eventBus';

import member from '@/services/member'
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'

export default {
name: 'membereditmodal',
  data () {
    return {
      show: false, 
      title: '',
      mode: '',
      form:{
        id: '',
        uuid: '',
        firstname: '',
        lastname: '',
        mobile_phone:'',
        alias:'',
        email:'',
        dob:'',
        sex:'male',
      },
      options: ['Male', 'Female'],
      radioNames: ['Gender',]
    }
  },
  mounted(){
  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_EDIT_DETAIL', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        member.getMemberbyID(params.data)
        .then(res => {
          self.form.id = res.data.id;
          self.form.uuid = res.data.uuid;
          self.form.firstname = res.data.firstname;
          self.form.lastname = res.data.lastname;
          self.form.dob = res.data.dob;
          self.form.email = res.data.email;
          self.form.sex = res.data.sex;
          self.form.mobile_phone = res.data.mobile_phone;
          self.form.alias = res.data.alias;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.show = false;
      this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')
      member.createMember(this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    update(id){
      this.show = false;
      this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')
      member.updateMember(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },  
   
  }
}
</script>
